import { SUBMISSION_KIT_TAGS } from '../../constants/SubmissionKit';
import api from '../../lib/api';
import {
  url_api_v1_profile_search,
  url_api_v1_project_recipients,
  url_api_v1_project_owners,
  url_api_v1_sb_add,
  url_api_v1_sb_edit_put,
  url_api_v1_sb_delete,
  url_api_v1_sb_get,
  url_api_v1_sb_profile_feedback_get,
  url_api_v1_sb_profile_invite,
  url_api_v1_sb_profile_remove,
  url_api_v1_sb_profile_upd,
  url_api_v1_sb_profiles_get,
  url_api_v1_sb_profiles_reorder,
  url_api_v1_sb_recipient_action_add,
  url_api_v1_sb_recipients_get,
  url_api_v1_sb_review_add,
  url_api_v1_sb_search,
  url_api_v1_sb_profile_notes_add,
  url_api_v1_sb_search_performer,
  url_api_v1_sb_profile_notes_update,
  url_api_v1_sb_get_performer,
} from '../../lib/apiUrl';
import { ProfileStatusMaster, SubmissionBoardModel } from '../submission_boards/component/SbModel';

class SubmissionBoardService {
  createSubmissionDocument = async (
    project: any,
    submissionBoardModel: SubmissionBoardModel,
    postData: any
  ) => {
    try {
      if (submissionBoardModel.id == undefined || submissionBoardModel.id <= 0) {
        const url = url_api_v1_sb_add.replace(':project_uuid', project.uuid);
        const response = await api.post(url, postData);
        if (response.status !== 200 && response.status !== 201) {
          throw new Error('Error creating job.');
        }
        let { submission_board, recipients } = response.data;
        submission_board.recipients = recipients;
        postData.id = submission_board.id;
        postData.created_at = submission_board.created_at;
        postData = { ...postData, ...submission_board };
      } else {
        const url = url_api_v1_sb_edit_put
          .replace(':sb_id', submissionBoardModel.id.toString())
          .replace(':project_uuid', project.uuid);
        const response = await api.put(url, postData);
        if (response.status !== 200 && response.status !== 201) {
          throw new Error('Error updating job.');
        }
        let { submission_board, recipients } = response.data;
        submission_board.recipients = recipients;
        postData = { ...submissionBoardModel, ...postData, ...submission_board };
      }
      return postData;
    } catch (error) {
      throw error;
    }
  };
  getProjectRecipients = async (project_uuid: string) => {
    try {
      let url = url_api_v1_project_recipients.replace(':project_uuid', project_uuid);
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching recipients.');
      }
      if ('users' in response.data) {
        const { users } = response.data;
        return users;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
  getProjectOwners = async (project_uuid: string) => {
    try {
      let url = url_api_v1_project_owners.replace(':project_uuid', project_uuid);
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching owners.');
      }
      if ('users' in response.data) {
        const { users } = response.data;
        return users;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
  getSbRecipients = async (project_uuid: string, sb_id: number) => {
    try {
      let url = url_api_v1_sb_recipients_get
        .replace(':sb_id', sb_id.toString())
        .replace(':project_uuid', project_uuid);
      let filter = '';
      const response = await api.get(url + filter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching submission_boards.');
      }
      if ('sb_recipients' in response.data) {
        let { sb_recipients } = response.data;
        return sb_recipients;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
  getRecipientFeedbackForSB = async (project_uuid: string, sb_id: number, profile_id: number) => {
    try {
      let url = url_api_v1_sb_profile_feedback_get
        .replace(':sb_id', sb_id.toString())
        .replace(':project_uuid', project_uuid);
      let filter = '';
      filter += (filter == '' ? '?' : '&') + `profile_id=${profile_id}`;
      const response = await api.get(url + filter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching submission_boards.');
      }
      const sb_profile_statuses = response.data;
      return sb_profile_statuses;
    } catch (error) {
      throw error;
    }
  };
  sendSbForReviewToRecipients = async (project_uuid: string, sb_id: number) => {
    try {
      let url = url_api_v1_sb_review_add
        .replace(':sb_id', sb_id.toString())
        .replace(':project_uuid', project_uuid); //`/api/v1/submission_boards/${selectedSubmissionBoard.id}/profiles`;
      let filter = '';
      const response = await api.post(url + filter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while sending for review to recipients.');
      }
      console.log(response);
      // const { profiles } = response.data;
      // selectedSubmissionBoard. = profiles;
      //      setProfiles(profiles);
    } catch (error) {
      throw error;
    }
  };
  addRecipientFeedback = async (
    project_uuid: string,
    sb_id: number,
    user_id: number,
    key_token: string,
    sb_recipient_id: number,
    profile_status: number,
    notes: string
  ) => {
    try {
      const url = url_api_v1_sb_recipient_action_add
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString()); // `/api/v1/submission_boards/${submissionBoard.id}/shortlist_profile`;

      const response = await api.post(url, {
        project_id: project_uuid,
        submission_board_id: sb_id,
        profile_id: user_id,
        key: key_token,
        sb_recipient_id: sb_recipient_id,
        profile_status: profile_status,
        notes: notes,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while sending for review to recipients.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getAllPerformers = async (
    project_uuid: string,
    sb_id: number,
    filterParams: any,
    pageParam: number,
    perPage: number
  ) => {
    try {
      let url = url_api_v1_profile_search.replace(':project_uuid', project_uuid);
      let queryFilter = '?page=' + pageParam + '&per_page=' + perPage + '&sb_id=' + sb_id;
      // let queryFilter = '';
      if (filterParams.firstName && filterParams.firstName.length > 0) {
        filterParams.firstName;
        queryFilter += (queryFilter == '' ? '?' : '&') + 'first_name=' + filterParams.firstName;
      }
      if (filterParams.lastName && filterParams.lastName.length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'last_name=' + filterParams.lastName;
      }
      if (filterParams.keyword && filterParams.keyword.trim().length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'keyword=' + filterParams.keyword.trim();
      }
      if (filterParams.selectedCountries && filterParams.selectedCountries.length > 0) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'countries=' + filterParams.selectedCountries.join(',');
      }
      if (
        filterParams.heightRange &&
        filterParams.heightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'heightRange=' + filterParams.heightRange.join(',');
      }

      if (
        filterParams.weightRange &&
        filterParams.weightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'weightRange=' + filterParams.weightRange.join(',');
      }

      if (filterParams.selectedGenders && filterParams.selectedGenders.length > 0) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'genders=' + filterParams.selectedGenders.join(',');
      }

      if (filterParams.onlyfav) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'onlyfav=1';
      } else if (filterParams.selectedUserGroups && filterParams.selectedUserGroups.length > 0) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'usergroups=' + filterParams.selectedUserGroups.join(',');
      }

      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching profiles.');
      }
      if ('users' in response.data) {
        let { users } = response.data;
        return users;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
  getSubmissionBoardsForPerformer = async (
    pageParam: number,
    perPage: number,
    keyword: string,
    sb_status: string,
    sortMode: string,
    project_uuid: string,
    submission_board_id: string

  ) => {
    try {
      let url = url_api_v1_sb_search_performer;
      let filter = '?page=' + pageParam + '&per_page=' + perPage;
      if (keyword) {
        filter += (filter == '' ? '?' : '&') + `keyword=${keyword.trim()}`;
      }
      if (sb_status != '') {
        filter += (filter == '' ? '?' : '&') + `sb_status=${sb_status.trim()}`;
      }
      if (sortMode != '') {
        filter += (filter == '' ? '?' : '&') + `sort=${sortMode.trim()}`;
      }
      if (project_uuid != '') {
        filter += (filter == '' ? '?' : '&') + `project_uuid=${project_uuid.trim()}`;
      }
      if (submission_board_id != '') {
        filter += (filter == '' ? '?' : '&') + `submission_board_id=${submission_board_id.trim()}`;
      }
      const response = await api.get(url + filter);
      const { submission_boards, current_user_media } = response.data;

      return {
        submission_boards,
        current_user_media,
      };
    } catch (error) {
      throw error;
    }
  };
  getSubmissionBoards = async (
    project_uuid: string,
    pageParam: number,
    perPage: number,
    keyword: string,
    sb_status: string,
    sortMode: string,
    sb_statuses: string
  ) => {
    try {
      let url = url_api_v1_sb_search.replace(':project_uuid', project_uuid);
      let filter = '?page=' + pageParam + '&per_page=' + perPage;
      if (keyword) {
        filter += (filter == '' ? '?' : '&') + `keyword=${keyword.trim()}`;
      }
      if (sb_status != '') {
        filter += (filter == '' ? '?' : '&') + `sb_status=${sb_status.trim()}`;
      }
      if (sb_statuses != '') {
        filter += (filter == '' ? '?' : '&') + `sb_statuses=${sb_statuses.trim()}`;
      }
      if (sortMode != '') {
        filter += (filter == '' ? '?' : '&') + `sort=${sortMode.trim()}`;
      }
      // let filter = '?page=1&per_page=' + 999999;
      const response = await api.get(url + filter);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getSubmissionBoard = async (
    project_uuid: string,
    sb_id: number,
    key_token: string,
    otp_valid: string
  ) => {
    try {
      let url = url_api_v1_sb_get
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());
      let filter = '';
      if (key_token) {
        filter += (filter == '' ? '?' : '&') + `key=${key_token.trim()}`;
      }
      if (otp_valid && otp_valid != '') {
        filter += (filter == '' ? '?' : '&') + `otp_valid=${otp_valid.trim()}`;
      }
      const response = await api.get(url + filter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching submission_boards.');
      }
      const {
        submission_board,
        profiles,
        recipients,
        coordinators,
        super_coordinator_name,
        episode_name,
        scene_name,
        submission_kit_tags,
      } = response.data;
      if (submission_board) {
        submission_board.episode_name = episode_name ?? [];
        submission_board.scene_name = scene_name ?? [];

        submission_board.recipients = recipients ?? [];
        submission_board.profiles = profiles ?? [];
        submission_board.coordinators = coordinators ?? [];
        submission_board.super_coordinator_name = super_coordinator_name ?? '';
        submission_board.submission_kit_tags = submission_kit_tags ?? SUBMISSION_KIT_TAGS;

        /*
        const sortOrder = {
          1: 1, // '1' gets rank 1 (comes first) accepted
          3: 2, // '3' gets rank 3 (comes first) accepted backup
          0: 3, // '0' gets rank 2 (comes second) pending
          2: 4, // '2' gets rank 3 (comes last) rejected
        };
        const anySelected = profiles.filter(
          (item) =>
            item.sb_profiles[0].profile_status == ProfileStatusMaster.Selected ||
            item.sb_profiles[0].profile_status == ProfileStatusMaster.BackupSelected
        );
        if (anySelected.length <= 0) {
          submission_board.profiles.sort((firstItem, secondItem) => {
            let statusA = firstItem.sb_profiles[0].profile_status;
            let statusB = secondItem.sb_profiles[0].profile_status;
            console.log('onestatus', statusA + ': ' + statusB);
            if (
              statusA != ProfileStatusMaster.Selected &&
              statusA != ProfileStatusMaster.BackupSelected
            ) {
              if (
                firstItem.sb_profiles[0].sb_profiles_statuses &&
                firstItem.sb_profiles[0].sb_profiles_statuses.length > 0
              ) {
                const accepted = firstItem.sb_profiles[0].sb_profiles_statuses.find(
                  (item) => item.profile_status == ProfileStatusMaster.Selected
                );
                if (accepted) {
                  statusA = 1;
                } else {
                  statusA = firstItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusA : 2;
                }
              } else {
                statusA = firstItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusA : 2;
              }
            }
            if (
              statusB != ProfileStatusMaster.Selected &&
              statusB != ProfileStatusMaster.BackupSelected
            ) {
              if (
                secondItem.sb_profiles[0].sb_profiles_statuses &&
                secondItem.sb_profiles[0].sb_profiles_statuses.length > 0
              ) {
                const accepted = secondItem.sb_profiles[0].sb_profiles_statuses.find(
                  (item) => item.profile_status == ProfileStatusMaster.Selected
                );
                if (accepted) {
                  statusB = 1;
                } else {
                  statusB =
                    secondItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusB : 2;
                }
              } else {
                statusB = secondItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusB : 2;
              }
            }
            console.log('name', firstItem.firstName + ': ' + secondItem.firstName);
            console.log('status', statusA + ': ' + statusB);
            const rankA = sortOrder[statusA];
            const rankB = sortOrder[statusB];
            console.log('rank', rankA + ': ' + rankB);
            return rankA - rankB;
          });
        } else {
          submission_board.profiles.sort((firstItem, secondItem) => {
            let statusA = firstItem.sb_profiles[0].profile_status;
            let statusB = secondItem.sb_profiles[0].profile_status;
            const rankA = sortOrder[statusA];
            const rankB = sortOrder[statusB];
            return rankA - rankB;
          });
        }
        */
        return submission_board;
      }
      throw new Error('Error while fetching submission_boards.');
    } catch (error) {
      throw error;
    }
  };
  invitePerformer = async (project_uuid: string, sb_id: number, postData: any) => {
    try {
      const url = url_api_v1_sb_profile_invite
        .replace(':sb_id', sb_id.toString())
        .replace(':project_uuid', project_uuid);
      const response = await api.post(url, postData);
      console.log(response);
      if (response.status !== 200 && response.status !== 201) {
        if (response.data && 'error' in response.data) {
          // showToast(response.data.error, 'danger');
          return response;
        }
        throw new Error('Error updating job.');
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
  addUserToProject = async (
    project_uuid: string,
    userData: any,
    key_token: string,
    otp_valid: string
  ) => {
    try {
      let filter = '';
      if (key_token) {
        filter += (filter == '' ? '?' : '&') + `key=${key_token.trim()}`;
      }
      if (otp_valid && otp_valid != '') {
        filter += (filter == '' ? '?' : '&') + `otp_valid=${otp_valid.trim()}`;
      }
      //vinod_check: do changes in backend
      const response = await api.post('/users' + filter, userData);
      if (response.status !== 200 && response.status !== 201) {
        if (response.data && 'error' in response.data) {
          throw new Error(response.data.error);
        }
        throw new Error('Error adding user to project.');
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
  removePerformerFromSubmissionBoard = async (
    project_uuid: string,
    sb_id: number,
    profile_id: number
  ) => {
    try {
      const url = url_api_v1_sb_profile_remove
        .replace(':project_uuid', project_uuid)
        .replace(':profile_id', profile_id.toString())
        .replace(':sb_id', sb_id.toString());

      const response = await api.delete(url, {});

      if (response.status !== 200 && response.status !== 201) {
        if (response.data && 'error' in response.data) {
          // showToast(response.data.error, 'danger');
          return response;
        }
        throw new Error('Error in removing performer from submission media.');
      }
      return response;
    } catch (error) {
      throw error;
    }
  };

  // getSBPerformers = async (
  //   project_uuid: string,
  //   sb_id: number,
  //   key_token: string,
  //   otp_valid: string,
  //   sortByPerformerStatus: boolean
  // ) => {
  //   try {
  //     let url = url_api_v1_sb_profiles_get
  //       .replace(':sb_id', sb_id.toString())
  //       .replace(':project_uuid', project_uuid); //`/api/v1/submission_boards/${submissionBoardModel.id}/profiles`;
  //     let filter = '';
  //     if (key_token) {
  //       filter += (filter == '' ? '?' : '&') + `key=${key_token.trim()}`;
  //     }
  //     if (otp_valid && otp_valid != '') {
  //       filter += (filter == '' ? '?' : '&') + `otp_valid=${otp_valid.trim()}`;
  //     }
  //     const response = await api.get(url + filter);
  //     if (response.status !== 200 && response.status !== 201) {
  //       throw new Error('Error while fetching submission_boards.');
  //     }
  //     const { profiles } = response.data;
  //     if (sortByPerformerStatus) {
  //       const sortOrder = {
  //         1: 1, // '1' gets rank 1 (comes first) accepted
  //         3: 2, // '3' gets rank 3 (comes first) accepted backup
  //         0: 3, // '0' gets rank 2 (comes second) pending
  //         2: 4, // '2' gets rank 3 (comes last) rejected
  //       };
  //       profiles.sort((firstItem, secondItem) => {
  //         let statusA = firstItem.sb_profiles[0].profile_status;
  //         let statusB = secondItem.sb_profiles[0].profile_status;
  //         console.log(statusA + ': ' + statusB);
  //         const rankA = sortOrder[statusA];
  //         const rankB = sortOrder[statusB];
  //         return rankA - rankB;
  //       });
  //     } else {
  //       const sortOrder = {
  //         1: 1, // '1' gets rank 1 (comes first) accepted
  //         0: 2, // '0' gets rank 2 (comes second) pending
  //         2: 3, // '2' gets rank 3 (comes last) rejected
  //       };
  //       profiles.sort((firstItem, secondItem) => {
  //         let statusA = firstItem.sb_profiles[0].profile_status;
  //         let statusB = secondItem.sb_profiles[0].profile_status;
  //         if (
  //           firstItem.sb_profiles[0].sb_profiles_statuses &&
  //           firstItem.sb_profiles[0].sb_profiles_statuses.length > 0
  //         ) {
  //           const accepted = firstItem.sb_profiles[0].sb_profiles_statuses.find(
  //             (item) => item.profile_status == ProfileStatusMaster.Selected
  //           );
  //           if (accepted) {
  //             statusA = 1;
  //           } else {
  //             statusA = firstItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusA : 2;
  //           }
  //         } else {
  //           statusA = firstItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusA : 2;
  //         }
  //         if (
  //           secondItem.sb_profiles[0].sb_profiles_statuses &&
  //           secondItem.sb_profiles[0].sb_profiles_statuses.length > 0
  //         ) {
  //           const accepted = secondItem.sb_profiles[0].sb_profiles_statuses.find(
  //             (item) => item.profile_status == ProfileStatusMaster.Selected
  //           );
  //           if (accepted) {
  //             statusB = 1;
  //           } else {
  //             statusB = secondItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusB : 2;
  //           }
  //         } else {
  //           statusB = secondItem.sb_profiles[0].sb_profiles_statuses.length <= 0 ? statusB : 2;
  //         }
  //         console.log(statusA + ': ' + statusB);
  //         const rankA = sortOrder[statusA];
  //         const rankB = sortOrder[statusB];
  //         return rankA - rankB;
  //       });
  //     }
  //     return profiles;
  //   } catch (error) {
  //     throw error;
  //   }
  // };
  // pending, final selection, backup, reject
  updatePerformerStatusSb = async (
    project_uuid: string,
    sb_id: number,
    profile_id: number,
    profile_status: number,
    key_token?: string,
    otp_valid?: string
  ) => {
    try {
      const url = url_api_v1_sb_profile_upd
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());
      let filter = '';
      if (key_token) {
        filter += (filter == '' ? '?' : '&') + `key=${key_token.trim()}`;
      }
      if (otp_valid && otp_valid != '') {
        filter += (filter == '' ? '?' : '&') + `otp_valid=${otp_valid.trim()}`;
      }
      const response = await api.put(url, {
        project_id: project_uuid,
        key: key_token,
        otp_valid: otp_valid,
        profile_id: profile_id,
        sb_profile: {
          submission_board_id: sb_id,
          profile_status: profile_status,
        },
      });
      if (response.status !== 200 && response.status !== 201) {
        if (response.data) {
          // showToast(response.data.error, 'danger');
          return response;
        }
        throw new Error('Error in removing performer from submission media.');
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
  updatePerformerNoteSb = async (
    project_uuid: string,
    sb_id: number,
    profile_id: number,
    notes: string
  ) => {
    try {
      const url = url_api_v1_sb_profile_upd
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());

      const response = await api.put(url, {
        project_id: project_uuid,
        submission_board_id: sb_id,
        profile_id: profile_id,
        notes: notes,
      });
      if (response.status !== 200 && response.status !== 201) {
        if (response.data && 'error' in response.data) {
          // showToast(response.data.error, 'danger');
          return response;
        }
        throw new Error('Error in removing performer from submission media.');
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
  // reorder shortlist cards
  reorderPerformer = async (project_uuid: string, sb_id: number, profile_ids: number[]) => {
    try {
      const url = url_api_v1_sb_profiles_reorder
        .replace(':sb_id', sb_id.toString())
        .replace(':project_uuid', project_uuid);
      const response = await api.patch(url, { profile_ids });
      if (response.status !== 200 && response.status !== 201) {
        if (response.data && 'error' in response.data) {
          return response;
        }
        throw new Error('Error in reordering performers.');
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
  updateStatusSubmissionBoard = async (
    project: any,
    submissionBoardModel: SubmissionBoardModel,
    postData: any
  ) => {
    try {
      const url = url_api_v1_sb_edit_put
        .replace(':sb_id', submissionBoardModel.id.toString())
        .replace(':project_uuid', project.uuid);
      const response = await api.put(url, postData);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error locking submission board.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  addProfileNote = async (
    project_uuid: string,
    sb_id: number,
    sb_profile_id: number,
    note: string,
    key_token?: string,
    otp_valid?: string
  ) => {
    const url = url_api_v1_sb_profile_notes_add
      .replace(':project_uuid', project_uuid)
      .replace(':sb_id', sb_id.toString());
    const payload = {
      project_id: project_uuid,
      submission_board_id: sb_id,
      sb_profile_id: sb_profile_id,
      note: note,
    };
    let filter = '';
    if (key_token) {
      filter += (filter == '' ? '?' : '&') + `key=${key_token.trim()}`;
    }
    if (otp_valid && otp_valid != '') {
      filter += (filter == '' ? '?' : '&') + `otp_valid=${otp_valid.trim()}`;
    }
    const response = await api.post(url + filter, payload);
    if (response.status !== 200 && response.status !== 201) {
      throw new Error('Error while adding profile note.');
    }
    return response.data;
  };
  updateNote = async (
    project_uuid: string,
    sb_id: number,
    note_id: number,
    sb_profile_id: number | undefined,
    note_text: string,
    key_token?: string,
    otp_valid?: string
  ) => {
    try {
      const url = url_api_v1_sb_profile_notes_update
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString())
        .replace(':note_id', note_id.toString());
      const payload = {
        project_id: project_uuid,
        submission_board_id: sb_id,
        note_id: note_id,
        sb_profile_id: sb_profile_id,
        note: note_text,
      };
      let filter = '';
      if (key_token) {
        filter += (filter == '' ? '?' : '&') + `key=${key_token.trim()}`;
      }
      if (otp_valid && otp_valid != '') {
        filter += (filter == '' ? '?' : '&') + `otp_valid=${otp_valid.trim()}`;
      }
      const response = await api.put(url + filter, payload);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error updating note.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getSbProfileDetailsPerf = async (
    project_uuid: string,
    sb_id: number
  ) => {
    try {
      let url = url_api_v1_sb_get_performer
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());
      let filter = '';
      const response = await api.get(url + filter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching submission_boards.');
      }
      // const {
      //   // submission_board,
      //   profile,
      //   // recipients,
      //   // coordinators,
      //   // episode_name,
      //   // scene_name,
      //   submission_kit_tags,
      // } = response.data;
      // if (profile) {
      return response.data;
      // }
      throw new Error('Error while fetching submission_boards.');
    } catch (error) {
      throw error;
    }
  };

  deleteSubmissionBoard = async (project_uuid: string, sb_id: number) => {
    try {
      const url = url_api_v1_sb_delete
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());
      const response = await api.delete(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error deleting submission board.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
const submissionBoardService = new SubmissionBoardService();

export default submissionBoardService;
